import React from 'react';
import LazyLoad from 'react-lazy-load';

import Image from '@spp/ui-image';

import { config } from '../../config';

// eslint-disable-next-line react/prop-types
const LazyLoadedImage = ({ subtype, byline, caption = { value: '' }, imageAsset }) => {
    const { value: altText = '' } = caption;
    const {
        image: { sizes: imageSizes },
    } = config;
    const isTopObject = subtype === 'top';

    // Drop sizes config for top image, makes it look better in VG+ articles
    const img = (
        <Image
            altText={altText}
            byline={byline}
            caption={caption}
            imageAsset={{
                ...imageAsset,
                sizes: imageSizes,
            }}
            sizes={isTopObject ? '100vw' : imageSizes}
            labels={config.image.labels}
            showFullCaption={config.image.showFullCaption}
        />
    );

    // if top object, do not lazy load
    if (isTopObject) {
        return img;
    }

    return (
        <LazyLoad offset={500} debounce={false} throttle={100}>
            {img}
        </LazyLoad>
    );
};

export default LazyLoadedImage;



/** WEBPACK FOOTER **
 ** ./src/local-components/article/LazyLoadedImage.js
 **/